<app-stepper-form
  [header]="formHeader"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.Declaration"
      [formGroupName]="StepsEnum.Declaration"
    >
      <h1 class="h1-heading">{{ isSpecialPurpose ? 'Form Description' : 'Description' }}</h1>

      @if (isSpecialPurpose) {
        <div [innerHtml]="specialPurposeCompanyDescription"></div>
      } @else {
        <div [innerHtml]="standardCompanyDescription"></div>
      }
    </section>


    <!--  ================================================================================================================  -->


    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.CompanyDetails"
      [formGroupName]="StepsEnum.CompanyDetails"
    >
      <h1 class="h1-heading">{{ currentStepLabel }}</h1>

      <div
        class="form-group new-company-name-wrapper"
        [hidden]="companyDetailsForm.value.useAcnAsNewCompanyName !== false"
      >
        <app-input
          label="New Company Name"
          formControlName="companyName"
        />
      </div>

      <div
        class="form-group"
        [hidden]="companyDetailsForm.value.useAcnAsNewCompanyName !== true"
      >
        <app-select
          label="Legal Element"
          formControlName="newLegalElementsIfAcnIsUsed"
          [options]="legalElementsOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group">
        <app-flags-autocomplete
          label="Jurisdiction of Registration"
          formControlName="jurisdiction"
          [options]="jurisdictionOptions"
        />
      </div>

      <!-- ADVANCED DETAILS START -->

      <div ngbAccordion class="pt-3">
        <div ngbAccordionItem>

          <div ngbAccordionHeader>

            <div ngbAccordionToggle class="d-flex justify-content-between align-items-center">
              <span class="px-3 accordion-header-text">Advanced Details</span>

              <button class="accordion-toggle-button btn" type="button">
                <i class="icon ic-chevron-down-20"></i>
              </button>
            </div>
          </div>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="pb-0">

              <div class="form-group">
                <app-yes-no-control
                  label="Use ACN as proposed company name?"
                  formControlName="useAcnAsNewCompanyName"
                />
              </div>

              <div [hidden]="companyDetailsForm.value.useAcnAsNewCompanyName !== false">
                <div class="form-group">
                  <app-yes-no-control
                    label="Has a name reservation been lodged to reserve the proposed new company name?"
                    formControlName="newNameReservedWithForm410"
                  />
                </div>

                <div class="form-group" [hidden]="companyDetailsForm.value.newNameReservedWithForm410 !== true">
                  <app-input
                    label="Reservation Number"
                    formControlName="reservationNumber"
                    [customErrors]="reservationNumberCustomErrors"
                  />
                </div>

                <div [hidden]="companyDetailsForm.value.newNameReservedWithForm410 !== true">
                  <div class="form-group">
                    <app-radio
                      formControlName="applicantType"
                      [label]="'Type of applicant'"
                      [options]="applicantTypeOptions"
                    ></app-radio>
                  </div>

                  <div class="form-group" [hidden]="companyDetailsForm.value.applicantType !== ApplicantType.Company">
                    <app-input
                      label="Company Name"
                      formControlName="applicantCompanyName"
                    />
                  </div>

                  <div class="form-group" [hidden]="companyDetailsForm.value.applicantType !== ApplicantType.Director">
                    <app-input
                      label="Individual Name"
                      formControlName="applicantIndividualName"
                      [customErrors]="directorFullNameValidatorMsg"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <app-yes-no-control
                    label="Is the proposed name identical to a registered business name(s)?"
                    formControlName="isProposedNameIdenticalToRegisteredBusinessName"
                  />
                </div>

                <div [hidden]="companyDetailsForm.value.isProposedNameIdenticalToRegisteredBusinessName !== true">
                  <div class="form-group">
                    <div class="form-group">
                      <app-checkbox
                        formControlName="abnConfirmation"
                        [label]="abnDeclarationMessage"
                      />

                      <div
                        class="pt-2"
                        [hidden]="!(companyDetailsForm.controls.abnConfirmation.touched && companyDetailsForm.controls.abnConfirmation.errors)"
                      >
                        <app-validation-error [control]="companyDetailsForm.controls.abnConfirmation"/>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <app-abn-masked-input
                      formControlName="businessNameHolderAbn"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <app-yes-no-control
                    label="Would you like ASIC to manually review the company registration?"
                    formControlName="manualReviewRequested"
                  />
                </div>

                <div class="form-group" [hidden]="companyDetailsForm.value.manualReviewRequested !== true">
                  <app-textarea
                    label="Manual Processing Reason"
                    formControlName="manualProcessingReason"
                  />
                </div>
              </div>

              <div class="form-group" [hidden]="isSpecialPurpose">
                <app-yes-no-control
                  label="Does this company have an Ultimate Holding Company?"
                  formControlName="haveUltimateHoldingCompany"
                />
              </div>

              <div
                class="uhc-part"
                [hidden]="companyDetailsForm.controls.haveUltimateHoldingCompany.value !== true || isSpecialPurpose"
                [formGroup]="companyDetailsForm.controls.ultimateHoldingCompany">
                <div class="form-group">
                  <app-flags-autocomplete
                    label="Place of incorporation of Ultimate Holding Company"
                    formControlName="ultimateHoldingCompanyCountry"
                  />
                </div>

                <div
                  class="form-group"
                  [hidden]="!CountriesService.isAustralianStateOrAustralia(companyDetailsForm.controls.ultimateHoldingCompany.controls.ultimateHoldingCompanyCountry.value)"
                >
                  <app-company-name-acn-form-group
                    nameTitle="Ultimate Holding Company Name"
                    acnTitle="Ultimate Holding Company ACN"
                    [formGroup]="companyDetailsForm.controls.ultimateHoldingCompany"
                    (companySelected)="onHoldingCompanySelected($event)"
                  />
                </div>

                <div
                  class="form-group"
                  [hidden]="CountriesService.isAustralianStateOrAustralia(companyDetailsForm.controls.ultimateHoldingCompany.controls.ultimateHoldingCompanyCountry.value)"
                >
                  <app-input
                    label="Ultimate Holding Company Name"
                    formControlName="aboardCompanyName"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- ADVANCED DETAILS END -->
    </section>

    <!--  ================================================================================================================  -->

    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.Address"
      [formGroupName]="StepsEnum.Address"
    >
      <h1 class="h1-heading">{{ currentStepLabel }}</h1>

      <div class="form-group">
        <app-address-and-occupier-form-group
          label="Registered Address"
          [careOfAllowed]="true"
          [suggestedAddresses]="suggestedAddresses"
          [formGroup]="addressForm.controls.registeredAddressAndOccupier"
          [changeDateHidden]="true"
        >
          <app-validation-error
            [control]="addressForm.controls.registeredAddressAndOccupier.controls.address"
            [customErrors]="addressesCustomErrors"
          />
        </app-address-and-occupier-form-group>
      </div>

      <div class="form-group">
        <app-yes-no-control
          label="Is principal address the same as the registered address?"
          formControlName="principalAddressSameAsRegisteredAddress"
        />
      </div>

      <div class="form-group" [hidden]="addressForm.controls.principalAddressSameAsRegisteredAddress.value !== false">
        <app-address-form-group
          label="Principal Address"
          [useInternationalAddresses]="false"
          [suggestedAddresses]="suggestedAddresses"
          [formGroup]="addressForm.controls.principalAddress"
        />

        <app-validation-error
          [control]="addressForm.controls.principalAddress"
          [customErrors]="addressesCustomErrors"
        />
      </div>
    </section>


    <!--  ================================================================================================================  -->


    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.Officeholders"
      [formGroupName]="StepsEnum.Officeholders"
    >
      <h1 class="h1-heading">{{ currentStepLabel }}</h1>

      @if (officeholdersForm.touched && (officeholdersForm.errors?.['foreignAddressForAllDirectors'] || officeholdersForm.errors?.['foreignAddressForAllSecretaries'])) {
        <div class="form-group">
          <app-validation-error
            [control]="officeholdersForm"
            [customErrors]="addressesCustomErrors"
          />
        </div>
      }

      <ul class="list-unstyled" formArrayName="officers">
        @for (officeholderFormGroup of officeholdersForm.controls.officers.controls; track officeholderFormGroup; let first = $first; let last = $last; let index = $index) {
          <li [formGroupName]="index">
            @if (officeholdersForm.controls.officers.controls.length > 1) {
              <div class="form-group d-flex justify-content-between align-items-center">
                <h3 class="h3-heading mb-0">
                  Officeholder {{ index + 1 }}
                </h3>

                <app-button
                  iconClass="icon ic-close-20"
                  (clickBtn)="removeOfficeholder(index)"
                />
              </div>
            }

            <div class="form-group">
              <app-individual-data-form-group
                [formGroup]="officeholderFormGroup"
                [useInternationalAddresses]="true"
                [suggestedAddresses]="suggestedAddresses"
                [fullNameSuggestions]="suggestedNames"
              />

              <app-validation-error
                [control]="officeholderFormGroup.controls.address"
                [customErrors]="addressesCustomErrors"
              />
            </div>

            <div class="form-group">
              <app-checkbox-group
                label="Position"
                formControlName="type"
                [options]="index == 0 ? firstOfficerCompanyStandardPositionTypesOptions : companyStandardPositionTypesOptions"
              />
            </div>

            <div class="form-group">
              @if (officeholderFormGroup.controls.type.value.includes(RelationshipType.Director)) {
                <app-din-masked-input
                  formControlName="din"
                />
              }
            </div>


            @if (!last) {
              <app-divider margin="1rem 0"/>
            }
          </li>
        }
      </ul>

      @if (this.officeholdersForm.controls.officers.touched && this.officeholdersForm.controls.officers.errors) {
        <div class="form-group">
          <app-validation-error
            [control]="this.officeholdersForm.controls.officers"
            [customErrors]="officeholdersPositionsCustomErrors"
          />
        </div>
      }

      <div>
        <app-button
          iconClass="icon ic-add-20"
          text="Add Officeholder"
          (clickBtn)="addOfficeholder()"
        />
      </div>
    </section>


    <!--  ================================================================================================================  -->


    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.Shareholders"
      [formGroupName]="StepsEnum.Shareholders"
    >
      <h1 class="h1-heading">{{ currentStepLabel }}</h1>

      @if (isSimpleShareholdersFillingMode) {
        <div class="form-group">
          <app-button
            text="I would like to edit the share structure"
            (clickBtn)="setIsSimpleShareholdersFillingMode(false)"
          />
        </div>
      }

      @for (shareholderFormGroup of shareholdersForm.controls.securityHolders.controls; track shareholderFormGroup.controls.relationshipId; let shareholderIndex = $index; let last = $last) {
        @if (shareholdersForm.controls.securityHolders.controls.length > 1) {
          <div class="form-group d-flex justify-content-between align-items-center">
            <h3 class="h3-heading mb-0">
              Shareholder {{ shareholderIndex + 1 }}
            </h3>

            <app-button
              iconClass="icon ic-close-20"
              (clickBtn)="removeShareholder(shareholderIndex)"
            />
          </div>
        }

        <div
          [formGroup]="shareholderFormGroup"
          [class.special-purpose-preview]="isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value && shareholderFormGroup.controls.individualId.disabled"
        >
          <div class="form-group">
            <app-select
              label="Shareholder Type"
              formControlName="shareholderType"
              [readonly]="isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value && shareholderFormGroup.controls.individualId.disabled"
              [options]="newShareholderTypesSelectOptions"
              [valuePrimitive]="true"
            />
          </div>

          <div
            class="form-group individual-data-wrapper"
            [hidden]="shareholderFormGroup.controls.shareholderType.value !== ShareholderTypesEnum.Individual"
          >
            <app-individual-data-form-group
              [formGroup]="shareholderFormGroup.controls.individualShareholder"
              [useInternationalAddresses]="true"
              [individualDataFormLabels]="individualDataFormLabels"
              [hiddenControls]="hiddenIndividualControls"
              [suggestedAddresses]="suggestedAddresses"
              [fullNameSuggestions]="suggestedNames"
              [readonly]="isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value && shareholderFormGroup.controls.individualId.disabled"
            />
          </div>

          <div
            [hidden]="shareholderFormGroup.controls.shareholderType.value !== ShareholderTypesEnum.Corporate"
            [formGroup]="shareholderFormGroup"
          >
            <div class="form-group">
              <app-company-name-acn-form-group
                [formGroup]="shareholderFormGroup"
                [hideAcn]="shareholderFormGroup.controls.isOverseasCompany.value!"
                [shouldLookForCompanyName]="!shareholderFormGroup.controls.isOverseasCompany.value"
                (companySelected)="onCorporateShareholderSelected($event, shareholderFormGroup)"
              >
                <div class="form-group">
                  <app-checkbox
                    label="This is an overseas company or the company doesn't have an ACN"
                    formControlName="isOverseasCompany"
                  />
                </div>
              </app-company-name-acn-form-group>
            </div>

            <div class="form-group">
              <app-address-form-group
                [careOfAllowed]="true"
                [formGroup]="shareholderFormGroup.controls.registeredAddress"
                [useInternationalAddresses]="shareholderFormGroup.controls.isOverseasCompany.value!"
                [addressFormLabels]="addressFormLabels"
                [suggestedAddresses]="suggestedAddresses"
              />
            </div>
          </div>

          <div
            class="form-group"
            [hidden]="shareholderFormGroup.controls.shareholderType.value !== ShareholderTypesEnum.JointShareholder"
          >
            <app-share-joint-security-holder
              [formControl]="shareholderFormGroup.controls.joint"
              [suggestedAddresses]="suggestedAddresses"
              [fullNameSuggestions]="suggestedNames"
              (deleteHolder)="onJointHolderRemoved()"
            />
          </div>

          <div class="share-related-part grid-full-width">
            <app-divider margin="24px 0"/>

            <div
              [hidden]="shareholderFormGroup.controls.shareholderType.value === null || shareholderFormGroup.controls.shareholderType.value === ShareholderTypesEnum.ExistingShareholder">
              <div class="form-group">
                <app-yes-no-control
                  label="Are the shares owned on behalf of another individual, company, trust or fund?"
                  formControlName="isNotBeneficialOwner"
                  [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                />
              </div>

              <div class="form-group" [hidden]="!shareholderFormGroup.controls.isNotBeneficialOwner.value">
                <app-input
                  label="Shares are owned on behalf of:"
                  formControlName="beneficialOwner"
                  [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                />
              </div>
            </div>

            @for (securityHolding of shareholderFormGroup.controls.securityTypes.controls; track securityHolding; let securityHoldingIndex = $index) {
              @if (securityHoldingIndex > 0) {
                <div class="form-group d-flex flex-row-reverse">
                  <app-button
                    iconClass="icon ic-close-20"
                    text="Remove Share"
                    (clickBtn)="removeShareholdersShareHolding(shareholderIndex, securityHoldingIndex)"
                  />
                </div>
              }

              <div class="share-numbers-grid" [formGroup]="securityHolding">
                <div class="form-group share-types">
                  <app-share-security-types-dropdown
                    formControlName="securityTypeId"
                    [options]="securityTypes"
                    [allowAddNewShareType]="shareholderFormGroup.controls.shareholderType.value !== null || shareholderFormGroup.controls.shareholderType.value !== ShareholderTypesEnum.ExistingShareholder"
                    [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                    [shareTypeOptions]="companyRegistrationShareTypesOptions"
                    (addShareType)="addShareType(shareholderIndex,securityHoldingIndex, $event)"
                  />
                </div>

                <div class="form-group number-of-shares-cancelled">
                  <app-input-number
                    label="Number of Shares Issued"
                    formControlName="number"
                    [min]="0"
                    [customErrors]="totalNumberOfSharesCustomErrors"
                    [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                  />
                </div>

                <div class="form-group total-paid">
                  <app-input-number
                    label="Total Paid"
                    formControlName="paid"
                    [min]="0"
                    [customErrors]="totalNumberOfSharesCustomErrors"
                    [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                  />
                </div>

                <div class="form-group total-unpaid">
                  <app-input-number
                    label="Total Unpaid"
                    formControlName="unpaid"
                    [min]="0"
                    [customErrors]="totalNumberOfSharesCustomErrors"
                    [readonly]="isSimpleShareholdersFillingMode && isSpecialPurpose && !!shareholderFormGroup.controls.individualId.value"
                  />
                </div>
              </div>

              <div class="form-group" [hidden]="
              securityHolding.controls.number.untouched
              && securityHolding.controls.paid.untouched
              && securityHolding.controls.unpaid.untouched
              && !securityHolding?.errors">
                <app-validation-error
                  [control]="shareholdersForm"
                  [customErrors]="customErrorsOfShareCancellationNumbers"
                />
              </div>
            }

            <div class="form-group d-flex flex-row-reverse">
              <app-button
                iconClass="icon ic-add-20"
                text="Add Share"
                btnColor="white"
                [hidden]="isSimpleShareholdersFillingMode"
                (clickBtn)="addSecurityHolding(shareholderIndex)"
              />
            </div>
          </div>
        </div>

        @if (!last) {
          <app-divider margin="1rem 0"/>
        }
      }

      <div class="form-group d-flex flex-row-reverse">
        <app-button
          class="w-100"
          iconClass="icon ic-add-20"
          text="Add Shareholder"
          (clickBtn)="addShareholder()"
        />
      </div>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.AuthorisedSignatories"
      [hidden]="currentStep !== StepsEnum.AuthorisedSignatories"
    >
      <app-authorised-signatories-step
        title="Authorised Signatories"
        [formGroup]="authorisedSignatoriesForm"
        [securityRegistryRecords]="authorisedSecurityRegistryRecords"
        [authSignatoriesValidators]="authSignatoriesValidators"
        (corporateHolderChange)="onCorporateHolderChangeChange($event)"
      />
    </section>
  </div>
</app-stepper-form>
